import { Checkbox } from "@blueprintjs/core";
import { IWidgetProps } from "decorator-form";
import React, { PureComponent } from "react";
import styled, { css } from "styled-components";

import { IViewProps, View } from "core/decorators/View";
import CheckBoxConfig from "./CheckboxConfig";

export interface ICheckBoxViewProps extends IViewProps<CheckBoxConfig> {
	options?: {
		inline?: boolean;
	};
	label?: string | JSX.Element;
	disabled?: boolean;
	readonly?: boolean;
	onChange: (value: boolean) => void;
	value: boolean;
}

interface IStyledCheckBoxProps {
	config: CheckBoxConfig;
}

export interface ICheckBoxState {
	className?: string;
}

const mapPropsToStyles = ({config}: IStyledCheckBoxProps) => css`
	&.bp3-control input:checked~.bp3-control-indicator {
		background-color: ${config.color};
	}
`;

const StyledCheckBox = styled(Checkbox)<IStyledCheckBoxProps>(mapPropsToStyles);

@View({id: "checkbox", configClass: CheckBoxConfig})
export class CheckBoxView extends PureComponent<ICheckBoxViewProps> {

	public render() {
		const { children, config, disabled, label, options = {}, readonly, value } = this.props;

		return (
			<StyledCheckBox
				config={config}
				checked={value}
				disabled={disabled || readonly}
				inline={options.inline}
				labelElement={label || children || ""}
				large={config.large}
				onChange={this.handleChange}
			/>
		);
	}

	private handleChange = (e: any) => {
		this.props.onChange(!!e.target.checked);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/checkbox/Checkbox.view.tsx